import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { categories, categoryBg, categoryIcons } from 'constant';
import { Box } from '@mui/material';
import { generateCardStyles } from 'sections/Articles/CardStyles';
import { useTheme } from '@emotion/react';

interface CardProps {
    title: string;
    category: string;
    previewText: string;
    videos?: string[];
 }

export function Card({
    title, category, previewText, videos = [],
}: CardProps) {
    const categoryIcon = categoryIcons[category] || categoryIcons.default;
    const videoIcon = categoryIcons['video'];
    const categoryBackground = categoryBg[category] || categoryBg.default;
    const to = `/${category}/${title}`;
    const hasVideos = videos?.length > 0 || category === 'video';

    const theme = useTheme();
    const styles = useMemo(() => generateCardStyles(theme), [theme]);

    return (
        <Box
            sx={{
                ...styles.wrapper,
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
            }}
        >
            <Box
                component={Link}
                to={to}
                sx={styles.imgWrapper}
                style={(category !== categories.video)
                    ? {
                        backgroundImage: `url(${hasVideos ? null : categoryBackground})`,
                        backgroundPositionY: '0',
                        backgroundPositionX: '-38px',
                    } : {}}
            >
                <Box
                    component="img"
                    src={hasVideos ? videoIcon : categoryIcon}
                    style={hasVideos ? {
                        height: '35px',
                    } : {
                        height: '87px',
                    }}
                    sx={styles.img}
                    alt="icon"
                />
                <Box className="preview">
                    {previewText}
                </Box>

            </Box>
            <Box component={Link} to={to} sx={styles.link}>{title}</Box>
        </Box>
    );
}
